var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnableclone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16.518,
  height: 19.126,
  viewBox: "0 0 16.518 19.126"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-content-copy",
  "data-name": "Icon material-content-copy",
  d: "M15.171,1.5H4.739A1.744,1.744,0,0,0,3,3.239V15.41H4.739V3.239H15.171Zm2.608,3.477H8.216A1.744,1.744,0,0,0,6.477,6.716V18.887a1.744,1.744,0,0,0,1.739,1.739h9.563a1.744,1.744,0,0,0,1.739-1.739V6.716A1.744,1.744,0,0,0,17.779,4.977Zm0,13.91H8.216V6.716h9.563Z",
  transform: "translate(-3 -1.5)",
  fill: "#7b7b7b"
})));
export { SvgEnableclone as ReactComponent };
export default __webpack_public_path__ + "static/media/enableclone.b7ee28713df524b9d93097a7c7ec1315.svg";